import React, {useState, useEffect} from 'react'
import styled from 'styled-components';
import { useTransition, animated} from 'react-spring';

 const ModalCore = styled.div`
    position:fixed;
    width:100%;
    display:flex;
    top:0;
    left:0;
    justify-content: center;
    align-items:center;
    height:100vh;
`;
const ModalCard = styled(animated.div)`
background:white;
color:black;
border-radius:15px;
box-shadow: 0 5px 15px rgba(0,0,0,0.5);
padding:20px;
max-width:200px;
width:100%`;


export const Modal = ({closeModal, animation}) => {
  return (
    <ModalCore>
        <ModalCard >
            Log in to Buy
            <button onClick={closeModal}> x</button>

        </ModalCard>
    </ModalCore>
)
}

export const ModalWrapper = ({trigger}) => {
    const [on, setOn ] = useState(trigger)

     useEffect(() => {
    setOn(trigger);
  }, [trigger]);
    const transition = useTransition(on, null, {
        from: {opacity:0, trnasform: 'translate3d(0, -40px, 0)'},
        enter: {opacity:1, trnasform: 'translate3d(0, 0, 0)'},
        leave: {opacity:0, trnasform: 'translate3d(0, -40px, 0)'}


    })
  return (
    <div>
        {transition.map(
            ({ item, key, props: animation }) => 
            item && <Modal animation={animation} closeModal={() => setOn(false)}/>
        )
}
      
    </div>

  )
}

export default ModalWrapper;